import * as React from 'react'
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from '@mui/material';

import { ISimpleNode } from '../node/nav/ISimpleNode';
import { useNodeSearch } from '../node/nav/useNodeSearch';
import FormatSatoshi from './FormatSatoshi';
import NodePubkey from './NodePubkey';


function itemFormat(node: ISimpleNode, props: any) {
    if (!node) {
        return '';
    }
    return <div {...props}>
        <div>
            <div className='font-semibold text-lg'>{node.label}</div>
            <div className=" text-xs">
                {node.channelCount} channels, ₿<FormatSatoshi satoshi={node.capacitySat} decimals={2} />
            </div>
            <div className="text-xs text-gray-500">
                <NodePubkey allowCopy={false} nodeId={node.id} maxCharacters={24} />
            </div>

        </div>
    </div>
}

type Props = {
    onChange?: (node: ISimpleNode) => void
    label?: string,
    disabled?: boolean,
    value?: ISimpleNode,
    className?: string,
    variant?: 'plain' | 'outlined'
    autoFocus?: boolean
}

const NodeInputField: React.FC<Props> = ({ autoFocus=false, variant="outlined", onChange, label, disabled, value = null, className= '' }: Props) => {

    const [fieldValue, setFieldValue] = React.useState<string>(null);
    const [options, setOptions] = React.useState<ISimpleNode[]>([]);
    const searchResult = useNodeSearch(fieldValue);

    const MIN_VALUE_LENGTH = 1;

    React.useEffect(() => {
        if (searchResult.loading) {
            return;
        }
        setOptions(searchResult.data?.elements || []);
    }, [searchResult.data]);


    function setResult(value: ISimpleNode | string) {
        const node = value as ISimpleNode;

        if (onChange) {
            onChange(node)
        }
    }

    function noOptionsText() {
        if (fieldValue === null || fieldValue.length < MIN_VALUE_LENGTH) {
            return 'Type min ' + MIN_VALUE_LENGTH + ' character';
        } else {
            return 'No nodes available';
        }
    }

    return (
        <div className={className}>
            <Autocomplete
            blurOnSelect={true}
                disablePortal
                options={[...options]}
                value={value}
                disabled={disabled}
                getOptionLabel={(node) => node.label + ' - ' + node.id}
                noOptionsText={noOptionsText()}
                style={{ width: '100%' }}
                onChange={(event, value) => {
                    setResult(value);
                }}
                renderOption={(props, node) => {
                    return itemFormat(node, props);
                }}
                renderInput={(params) => {
                    if (variant === 'plain') {
                        (params.InputProps as any).style = {
                            paddingTop: '6px', 
                            paddingBottom: '6px', 
                            paddingLeft: '10px',
                            paddingRight: '50px',
                            fontSize: '1rem'
                        };
                        (params.InputProps as any).disableUnderline = true;
                    }
                    const fieldVariant = variant === 'plain'? 'standard': 'outlined';

                    return <TextField
                        {...params} label={label} placeholder="Alias or pubkey"
                        variant={fieldVariant}
                        disabled={disabled}
                        onChange={(event) => {
                            
                            setFieldValue(event.target.value);
                        }}
                        className="bg-white no-border rounded focus:outline-none"
                        autoFocus={autoFocus}
                    />;
                }}

                isOptionEqualToValue={(option, value) => {
                    return option.id === option.id;
                }}
            />
        </div>
    );
}

export default NodeInputField;